import React from 'react';

const ButtonComponent = ({name, className}) => {
	return (
		<button
			className={className}
		>
			{name}
		</button>
	);
};

export default ButtonComponent;
